/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import { BaseEvent as t } from "./base-event.mjs";
class n extends t {
  /**
   * @hidden
   */
  constructor(s, e) {
    super(e);
  }
}
export {
  n as BeforeResetEvent
};
